import { render } from "./participants.vue?vue&type=template&id=00137d53&scoped=true"
import script from "./participants.vue?vue&type=script&lang=js"
export * from "./participants.vue?vue&type=script&lang=js"

import "./participants.vue?vue&type=style&index=0&id=00137d53&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00137d53"]])

export default __exports__